import { useState, useEffect } from 'react';
import { SyncQueue, SyncState } from '../utils/SyncQueue';

export const useSyncStatus = () => {
  const [state, setState] = useState<SyncState>(SyncQueue.getSyncState());

  useEffect(() => {
    const handleSyncChange = (e: any) => {
      if (e.detail) {
        setState(e.detail);
      }
    };

    window.addEventListener('sync-state-changed', handleSyncChange);
    
    // Initial sync in case we missed an event
    setState(SyncQueue.getSyncState());

    return () => {
      window.removeEventListener('sync-state-changed', handleSyncChange);
    };
  }, []);

  return state;
};
